import React from 'react';
import PropTypes from 'prop-types';
import { Controller, useForm } from 'react-hook-form';
import styles from './Form.module.sass';
import Input from '../../../../ui_kit/input/Input';
import Button from '../../../../ui_kit/button/Button';
import { normalizePhone } from '../../../../services/format_phone_number';
import { emailIsValid, phone as phoneIsValid } from '../../../../services/validations';

const validateRequiredField = {
  validate: (value) => {
    if (value.trim()) { return true; }

    return 'This field is required';
  },
};

function Form(props) {
  const {
    handleSubmit, control, formState: { errors }, register,
  } = useForm({
    mode: 'onTouched',
  });

  const { onSubmit, loading } = props;

  return (
    <form className={styles.form} onSubmit={handleSubmit(onSubmit)}>
      <Input
        className={styles.input}
        label="Name*"
        placeholder="Either creator's name or agent/manager's name"
        error={errors.name?.message}
        {...register('name', validateRequiredField)}
      />
      <Input
        className={styles.input}
        label="Creator's social media handle*"
        placeholder="@"
        error={errors.socialMediaHandle?.message}
        {...register('socialMediaHandle', validateRequiredField)}
      />
      <Input
        className={styles.input}
        label="Creator’s largest social media platform*"
        placeholder="e.g. Instagram, TikTok, YouTube"
        error={errors.largestSocialMediaPlatform?.message}
        {...register('largestSocialMediaPlatform', validateRequiredField)}
      />
      <Input
        className={styles.input}
        label="Size of Creator’s largest social media platform*"
        placeholder="Following size"
        error={errors.socialMediaPlatformSize?.message}
        {...register('socialMediaPlatformSize', validateRequiredField)}
      />
      <Input
        className={styles.input}
        label="Contact email address*"
        placeholder="For agent, manager or creator to receive intro email from Volition"
        error={errors.email?.message}
        {...register('email', {
          required: 'This field is required',
          validate: ((email) => {
            if (!email.trim()) {
              return 'Email is required';
            }

            if (!emailIsValid(email)) {
              return 'Email is invalid';
            }

            return true;
          }),
        })}
      />
      <Controller
        name="phone"
        control={control}
        rules={{
          validate: ((phone) => {
            if (!phone?.trim()) { return true; }

            if (!phoneIsValid(phone)) {
              return 'Phone is invalid';
            }

            return true;
          }),
        }}
        render={({ field }) => (
          <Input
            {...field}
            className={styles.input}
            label="Contact phone number"
            placeholder="US/Canada phone numbers only"
            error={errors.phone?.message}
            type="tel"
            onChange={(e) => field.onChange(normalizePhone(e.target.value))}
          />
        )}
      />
      <Button color="transparent-blue" className={styles.button} type="submit" loading={loading}>Submit</Button>
    </form>
  );
}

Form.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
};

export default Form;
